/** Имя, под которым пользовательские дашборды хранятся на сервере среди совместных пресетов */
export const DASHBOARD_PRESETS_TABLE_NAME = 'dashboardPresets';

/**
 * Начало ключа совместного дашборда: `shared:<id записи сервера>`. Личные дашборды ключуются
 * uuid, поэтому с ключом совместного не совпадают. Под этим ключом совместный дашборд лежит
 * и в настройках пользователя (`activePresetId`, `sharedFilters`).
 */
const SHARED_DASHBOARD_PRESET_PREFIX = 'shared:';

/** Собирает ключ совместного дашборда по идентификатору его записи на сервере. */
export const buildSharedDashboardPresetId = (serverId: number): string =>
  `${SHARED_DASHBOARD_PRESET_PREFIX}${serverId}`;

/**
 * Возвращает идентификатор серверной записи совместного дашборда либо `null`, если ключ
 * принадлежит личному дашборду.
 */
export const parseSharedDashboardPresetId = (presetId: string): number | null => {
  if (!presetId.startsWith(SHARED_DASHBOARD_PRESET_PREFIX)) return null;
  const serverId = Number(presetId.slice(SHARED_DASHBOARD_PRESET_PREFIX.length));
  return Number.isInteger(serverId) ? serverId : null;
};
